import { createReducer, on } from '@ngrx/store';
import {
  CloseEditDateDialog,
  DateChanged,
  OpenUpdateDateDialog,
  UpdateDateSuccess,
} from '../actions/edit-date.actions';

export interface EditDate {
  dateFormat: string;
  date: Date;
  column: string;
}

const initialState: EditDate = {
  dateFormat: '',
  date: new Date(),
  column: '',
};

export const DateReducer = createReducer(
  initialState,
  on(OpenUpdateDateDialog, (state, { dateFormat, column }) => ({
    ...state,
    dateFormat,
    date: new Date(dateFormat),
    column,
  })),
  on(UpdateDateSuccess, () => initialState),
  on(CloseEditDateDialog, () => initialState),
  on(DateChanged, (state, { dateFormat, date }) => ({
    ...state,
    date,
    dateFormat,
  })),
);
